export default {
  storedCheckoutData (state) {
    return JSON.parse(localStorage.getItem('checkoutFormData'));
  },

  formData (state) {
    let form = state.form
    delete form.payment_group
    delete form.saveInformation

    if (form.delivery === 'delivery') {
      delete form.date
      delete form.time
    } else {
      delete form.address_1
      delete form.address_2
      delete form.state_id
      delete form.city_id
    }

    return form
  },
}
